import { useAccessiblePayerCustomerIds } from '@folio/hooks/useAccessiblePayerCustomerIds';
import { useAssertedParams } from '@folio/lib';
import { usePolicyOnDashboard } from '@folio/utils/usePolicyOnDashboard';
import { useQueries } from '@tanstack/react-query';
import { viewSpecificControllerListCustomerPaymentMethodsQueryOptions } from 'korint-sdk';
import { AlertTriangleIcon, ChevronRightIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { Alert, AlertDescription, AlertTitle } from '../../components/ui/alert';
import { buttonVariants } from '../../components/ui/button';
import { Group } from '@folio/components/ui/flex';

export function PolicyholderPaymentFailureBanner() {
  const { t } = useTranslation();
  const { policyId, branchId } = useAssertedParams();
  const { policy } = usePolicyOnDashboard();
  const payerCustomerIds = useAccessiblePayerCustomerIds(policy);

  const paymentMethodQueries = useQueries({
    queries: payerCustomerIds.map(customerId => ({
      ...viewSpecificControllerListCustomerPaymentMethodsQueryOptions(customerId),
    })),
  });

  const shouldShowBanner = paymentMethodQueries.some(
    query =>
      query.data !== undefined && query.data.data.every(({ deletedAt }) => deletedAt != null),
  );

  if (!shouldShowBanner) return null;

  const paymentMethodsLink = branchId
    ? `/policyholder/${policyId}/${branchId}/payment-methods`
    : `/policyholder/${policyId}/payment-methods`;

  return (
    <Alert variant="destructive" className="flex justify-between items-center bg-card">
      <Group align="start" gap={3}>
        <AlertTriangleIcon />
        <div>
          <AlertTitle>{t('paymentFailureBanner.title')}</AlertTitle>
          <AlertDescription>{t('paymentFailureBanner.description')}</AlertDescription>
        </div>
      </Group>
      <Link to={paymentMethodsLink} className={buttonVariants()}>
        {t('paymentFailureBanner.cta')}
        <ChevronRightIcon className="h-4 w-4 ml-2" />
      </Link>
    </Alert>
  );
}
